<template>
    <!-- 指南详情 -->
    <div class="container">
        <Title></Title>
        <div class="box">
            <advertisement />
            <interiorH :name=name />
            <!-- 内容部分--头 -->
            <div class="introduction">
                <h5>{{ info.title }}</h5>
                <p class="data">{{ info.update_time }}</p>
                <p class="content" v-html="info.description">
                </p>
            </div>
            <!-- 更多推荐--头 -->
            <div class="more">
                <p>更多推荐</p>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <!-- 更多推荐内容--头 -->
            <div class="morecontent">
                <div>
                    <!-- 内容--头 -->
                    <div @click="path(item.id, item.category_id)" class="recommend_list"
                        v-for="(item, index) in recommend_list">
                        <div>
                            <img :src="item.thumbImage.fullImageUrl" alt="" />
                        </div>
                        <div class="content">
                            <h5>{{ item.title }}</h5>
                            <p class="desc">
                                {{ item.description }}
                            </p>
                            <span>{{ item.author }}</span>
                        </div>
                    </div>
                    <!-- 内容--尾部 -->
                </div>
            </div>
            <!-- 版权信息 -->
            <copyright />
        </div>
    </div>
</template>
  
<script>
import Title from "../components/title.vue";
import copyright from "../components/copyright.vue";
import interiorH from "../components/interiorH.vue";
import axios from "axios";
export default {
    components: {
        Title,
        copyright,
        interiorH
    },
    data() {
        return {
            info: {},
            recommend_list: [],
            name: null
        };
    },
    mounted() {
        this.getInfo(this.$route.query.article_id, this.$route.query.category_id)

        if (this.$route.query.category_id == 4) {
            this.name = 3
        } else if (this.$route.query.category_id == 1) {
            this.name = 1
        } else if (this.$route.query.category_id == 5) {
            this.name = 4
        }
    },
    methods: {
        async getInfo(article_id, category_id) {
            let res = await axios.post(`/api/article/detail`, {
                article_id,
                category_id
            })

            this.info = res.data.data.article
            this.recommend_list = res.data.data.recommend_list
        },
        path(article_id, category_id) {
            this.getInfo(article_id, category_id)

            // this.$router.push({ path: "/fingerpostI", query: { article_id, category_id } })
        }
    }

};
</script>
  
<style scoped>
.box {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 3rem 1rem 0 1rem;
}

a {
    text-decoration: none;
}

/* p {
    width: 100%;
    height: 13.5rem;
    border-radius: 0.5rem;
    margin-top: 2.375rem;
    position: relative;
  } */
.banner {
    position: relative;
    width: 22rem;
    height: 8.5rem;
    margin: 1.875rem auto;
    text-align: center;
}

.banner img {
    width: 100%;
    height: 100%;
}

.banner h5 {
    width: 100%;
    position: absolute;
    font-size: 1rem;
    color: #fff;
    top: 50%;
    margin-top: -0.5rem;
}

.nav {
    margin-top: -0.625rem;
    display: flex;
    margin-bottom: 1.75rem;
    overflow: auto;
}

::-webkit-scrollbar {
    display: none;
}

.nav .nav-01 span {
    display: inline-block;
    width: 0.9375rem;
    height: 0.9375rem;
    background: url(../assets/img/base/tjzxjj.svg) no-repeat center center;
}

.nav .nav-01 p {
    display: inline-block;
    font-weight: 500;
    color: #2b4ca4;
}

.nav a {
    font-size: 0.875rem;
    color: #333;
    white-space: nowrap;
    margin-right: 0.875rem;
}

.introduction {
    display: flex;
    flex-direction: column;
    margin: 0 0.625rem;
}

.introduction h5 {
    font-size: 1.0625rem;
    font-weight: 700;
    color: #333;
    margin: 0 auto;
}

.introduction .data {
    margin-top: 0.375rem;
    font-size: 0.75rem;
    color: #7d8184;
    text-align: right;
}

.introduction .content {
    margin-top: 0.9375rem;
    font-size: 0.875rem;
    line-height: 20px;

}

.content h5 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /* autoprefixer: ignore next */
    -webkit-line-clamp: 2;
}

.more {
    margin-top: 3.125rem;
}

.more p {
    display: inline-block;
    font-size: 0.9375rem;
    color: #393c3f;
    margin-right: 0.3125rem;
}

.more span {
    display: inline-block;
    width: 0.25rem;
    height: 0.8294rem;
    transform: skew(-30deg);
    -webkit-transform: skew(-30deg);
    -moz-transform: skew(-30deg);
    -o-transform: skew(-30deg);
    -ms-transform: skew(-30deg);
    background-color: #0982f9;
}

.morecontent {
    margin-top: 0.875rem;
    display: flex;
    flex-direction: row;
}

.recommend_list {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
}

.desc {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /* autoprefixer: ignore next */
    -webkit-line-clamp: 2;
}

.morecontent img {
    width: 6.6875rem;
    height: 5rem;
    margin-right: 0.5rem;
}

.morecontent .content h5 {
    font-size: 0.875rem;
    font-weight: 500;
    color: #2b4ca4;
}

.morecontent .content p {
    font-size: 0.8125rem;
    color: #333;
    margin-top: 0.375rem;
}

.morecontent .content span {
    font-size: 0.8125rem;
    color: #e04044;
}
</style>
  


// WEBPACK FOOTER //
// src/page/fingerpostI.vue